var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8793 15.625H63.5582C65.5507 15.625 67.1875 17.2618 67.1875 19.2543V70.2785V80.1702C67.1875 82.1628 65.5507 83.7995 63.5582 83.7995H34.8793C32.8868 83.7995 31.25 82.1628 31.25 80.1702V70.2785V19.2543C31.25 17.1906 32.8868 15.625 34.8793 15.625ZM58.5056 69.2822H39.7184C37.7259 69.2822 36.0891 67.6454 36.0891 65.6528V27.9363C36.0891 25.9437 37.7259 24.3069 39.7184 24.3069H58.5056C60.4981 24.3069 62.1349 25.9437 62.1349 27.9363V65.6528C62.1349 67.6454 60.4981 69.2822 58.5056 69.2822ZM49.1832 79.9567C47.5464 79.9567 46.1231 78.5334 46.1231 76.8967C46.1231 75.2599 47.5464 73.8366 49.1832 73.8366C50.8199 73.8366 52.2432 75.2599 52.2432 76.8967C52.2432 78.5334 50.8199 79.9567 49.1832 79.9567Z",
    fill: "#39B980"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.e713844e718729241c65c50f961a8f62.svg";
export { ForwardRef as ReactComponent };